import { render, staticRenderFns } from "./servicios.vue?vue&type=template&id=1af74605&scoped=true"
import script from "./servicios.vue?vue&type=script&lang=js"
export * from "./servicios.vue?vue&type=script&lang=js"
import style0 from "./servicios.vue?vue&type=style&index=0&id=1af74605&prod&lang=css"
import style1 from "./servicios.vue?vue&type=style&index=1&id=1af74605&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af74605",
  null
  
)

export default component.exports